import "react-app-polyfill/ie11"; // For IE 11 support
import "react-app-polyfill/stable";
import "core-js";
import "./polyfill";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store";
import { currentEnv, isMaintenanceTime } from "./config/config";
import Outage from "./revampPages/Outage";
import * as Sentry from "@sentry/react";

Sentry.init({
	dsn: "https://e486677cbc950ba4404332783c5dbe49@o4508326426181632.ingest.de.sentry.io/4508496551411792",
	integrations: [
		Sentry.browserTracingIntegration(),
		Sentry.replayIntegration(),
	],
	tracesSampleRate: 1.0,
	replaysSessionSampleRate: 0.1,
	replaysOnErrorSampleRate: 1.0,
	environment: currentEnv
});

ReactDOM.render(
	<Provider store={store}>
		<Sentry.ErrorBoundary>
			{isMaintenanceTime ?
				<Outage />
				:
				<App />
			}
		</Sentry.ErrorBoundary>
	</Provider>,
	document.getElementById("root")
);
serviceWorker.unregister();
reportWebVitals();
